var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect-item',{attrs:{"id":"id_empresa","custom-label":_vm.label,"options":_vm.empresasOptions,"placeholder":"Seleccione empresa","track-by":"id_empresa","loading":_vm.isLoading},model:{value:(_vm.empresas),callback:function ($$v) {_vm.empresas=$$v},expression:"empresas"}})
}
var staticRenderFns = []

export { render, staticRenderFns }